<template>
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <div v-if="auth.isAuthenticated" class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="card border-light text-center dashboard-card">
          <h3 class="card-title">SIM Inventory</h3>
          <SimPie />
        </div>
      </div>
      <div class="col">
        <div class="card border-light text-center dashboard-card">
          <h3 class="card-title">Top Users</h3>
          <p class="text-warning"><small><em>
                Usage may not include UDP traffic and/or UDP headers.
              </em></small></p>
          <UsageChart />
        </div>
      </div>
      <div class="col">
        <div class="card border-light text-center dashboard-card">
          <h3 class="card-title">Useful Links</h3>
          <UsefulLinks />
        </div>
      </div>
    </div>
    <div v-if="!auth.isCustomer" class="row">
      <QosGraph />
    </div>
    <div v-if="auth.isAdmin" class="row">
      <h3 class="text-danger text-center">Admin-only (TODO)</h3>
      <ul class="text-danger">
        <li>Billing (CDR stats / details)</li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { useAuthStore } from '@/stores/authStore';
import SimPie from '@/components/SimPieComponent.vue';
import UsageChart from '@/components/UsageGraphComponent.vue';
import UsefulLinks from '@/components/UsefulLinksComponent.vue';
import QosGraph from '@/components/QosGraphComponent.vue';

const auth = useAuthStore();
</script>

<style>
.dashboard-card {
  margin: 0;
  display: flex;
  place-items: center;
  min-height: 25rem;
}
</style>